import { render, staticRenderFns } from "./CommissioneDetail.vue?vue&type=template&id=5fa1e136&scoped=true&"
import script from "./CommissioneDetail.vue?vue&type=script&lang=ts&"
export * from "./CommissioneDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CommissioneDetail.vue?vue&type=style&index=0&id=5fa1e136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1e136",
  null
  
)

export default component.exports